export enum InteractionType {
    select = 1,
    /** Применяет Select ко всем слоям */
    selectAll = 2,
    draw = 3,
    modify = 4,
    snap = 5
}
